import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/interessent'
import adress_api from '@/api/adresse'
import { SET_ADRESSE, SET_IDS, SET_ADRESSMELDUNG, SET_ADRESSDATEN, SET_LANGUAGE } from './mutations.type'
import { LADE_ADRESSMELDUNG, LADE_ADRESSDATEN } from './actions.type'

/**
 * Dokumentation zum Store:
 * https://vuex.vuejs.org/guide/
 */

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adressdaten: null,
    adresse: {},
    ids: {},
    adressmeldung: '',
  },
  mutations: {
    [SET_ADRESSE](state, val) {
      state.adresse = val
    },
    [SET_IDS](state, val) {
      state.ids = val
    },
    [SET_ADRESSMELDUNG](state, val) {
      state.adressmeldung = val
    },
    [SET_ADRESSDATEN](state, val) {
      state.adressdaten = val
    },
    [SET_LANGUAGE](state, val) {
      state.language = val
    },
  },
  actions: {
    async loadLanguage({ commit }) {
      let response = await api.language.getLanguage()
      commit(SET_LANGUAGE, response.data)
    },
    async [LADE_ADRESSMELDUNG](context, adressmeldungID) {
      try {
        let response = await api.getAdressmeldung(adressmeldungID)
        if (response.data.state === 200) {
          context.commit(SET_ADRESSMELDUNG, response.data.msg)
        }
      } catch (error) {
        //console.error("Laden der Adressmeldung nicht möglich");
      }
    },
    async [LADE_ADRESSDATEN](context, adressId) {
      try {
        let response = await adress_api.getAdressdaten(adressId)
        if (response.status === 200) {
          context.commit(SET_ADRESSDATEN, response.data)
        }
      } catch (error) {
        //console.error("Laden der Adressdaten nicht möglich");
      }
    },
  },
})
